import { useState, useEffect, useMemo } from "react";
import { debounce } from "lodash";
import { Input } from "antd";
import { Icon } from "Components";

const DebounceInput = ({ placeholder, setDebouncedSearch, className = "", debounceSearch = null, showClearOption = false } : {
    placeholder: string;
    debounceSearch?: string | null;
    className?: string;
    setDebouncedSearch: (value: string) => void;
    showClearOption?: boolean
}) => {
    const [search, setSearch] = useState("");

    const handleClearAction = () => {
        if(showClearOption && search)  {
            setSearch("");
            setDebouncedSearch("");
        }
    }

    const debouncedSetSearch = useMemo(
        () =>
            debounce((value: string) => {
                setDebouncedSearch(value);
            }, 500),
    []);

    useEffect(() => {
        return () => debouncedSetSearch.cancel();
    }, [debouncedSetSearch]);

    useEffect(() => {
        if(debounceSearch !== null) setSearch(debounceSearch)
    }, [debounceSearch])

    return <Input.Search
        placeholder={placeholder}
        value={search}
        className={className}
        onChange={(e: any) => {
            const { value } = e.target;
            setSearch(value);
            const searchValue = value.trimEnd();
            if(!searchValue.length || searchValue.length > 2) debouncedSetSearch(value);
        }}
        suffix={<Icon type={(showClearOption && search) ? "close" : "search"} onClick={handleClearAction} />}
    />
}

export default DebounceInput;